import React, { useEffect } from 'react';
;
/**
 * Dismissable toaster message component
 * @param {IToaster}
 * @returns
 */
export var Toaster = function (_a) {
    var message = _a.message, className = _a.className, _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.timer, timer = _c === void 0 ? 3000 : _c, onClose = _a.onClose;
    useEffect(function () {
        if (message) {
            if (onClose) {
                setTimeout(function () {
                    onClose();
                }, timer);
            }
        }
    }, [message]);
    return (React.createElement(React.Fragment, null, message &&
        React.createElement("div", { className: "toaster-container" },
            React.createElement("div", { className: "toaster " + type + " " + className },
                React.createElement("div", { className: "message" },
                    message,
                    onClose &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "padder" }),
                            React.createElement("div", { className: "close", onClick: onClose }, "\u00D7")))))));
};
